// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__AIX7L","resendInfoText":"OnGoingPaymentBox_resendInfoText__uV7MP"};